/**
 * Dashboard - Create or update an event
 */

'use strict';

var helpers = require('../../misc/helpers');
var formImages = require('../formImages');

// Constructor
var FrontDashboardEventsForm = function () {
    var bodyClasses = $('body').attr('class').split(" ");
    var i = 0;
    var found = false;
    while (i < bodyClasses.length && !found) {
        if (bodyClasses[i].indexOf('dashboard-events-edit-') == 0) { // starts with
            found = true;
        }
        i++;
    }

    if (!found) {
        if (!$('body').hasClass('dashboard-events-create')) {
            return;
        }
    }

    $(document).ready((function () {
        // Create or update?
        var id = parseInt($('#idPostEdited').val());
        if (id > 0) {
            this.isUpdate = true;
            this.idEvent = id;
        }

        this.maxImages = 1;
        if ($('#userIsPartner').val() == 1) {
            this.maxImages = 4;
        }

        formImages.addImages(this.maxImages, this.isUpdate);

        if (this.isUpdate) {
            this.initUpdate();
            formImages.manageImages();
            this.updateEventName();
        } else {
            this.initSubjectSearch();
            this.initSubjectAddNew();
            this.validateSubject();
            this.copyFeaturedImage();
        }

        this.initPlaceDropdown();
        this.initPlaceOther();
        this.initActorsDropdown();
        this.initActorsAutocomplete();
        this.initPlacesAutocomplete();
        this.onCategoryChange();
        this.initShows();
        this.removeShowRow();
        this.updateContainerHeightOnTextarea();
        this.submitForm();
    }).bind(this));
};

FrontDashboardEventsForm.prototype = {
    isUpdate: false,
    idEvent: 0,
    maxImages: 1,
    lockAjaxForm: false,
    lockAjaxAutopopulate: false,
    lockAjaxCopyFeaturedImage: false,
    subject: {id: 0, name: '', season: ''},
    select2Place: null,
    select2Actor: null,
    select2CastingDirecting: null,
    select2CastingDirectingAssistantship: null,
    select2CastingAuthor: null,
    select2CastingCompagnies: null,
    showsDatePickers: [],
    showsTimePickers: [],
    customPlaceOpeningHours: false,

    initUpdate: function() {
        var self = this;

        $('section#subject .first-step').hide();
        $('section#subject .second-step').fadeIn();

        $('section.hide-on-load').fadeIn(1000, function() {
            self.updateContainerHeight();
        });

        $('.section-actions.bottom').show();
        $('.section-actions .fake-submit').removeClass('disabled');

        setTimeout(function() {
            // Wait for AJAX requests and other stuff...
            $('.section-actions').css('opacity', 1);
            $('#edit-wait').hide();
            $('#event-form').fadeIn();
            // Just in case...
            $('main#content > .col').matchHeight();
        }, 2000);

        // Autopulate fields with data of the edited event
        
        self.autopopulateFieldsFromShareableEvent(self.idEvent);
    },

    /**
     * Search subject by name (with select2)
     */
    initSubjectSearch: function() {
        var self = this;

        var $btnSubmit = $('section#subject .btn-validate-subject');

        $('.section-actions.bottom').hide();

        // Init select2 dropdown
        $('#event-subject').select2({
            placeholder: "Nom de l'événement",
            allowClear: true,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_subjects',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    return {
                        results: selectData.data,
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.subjectDropdownTplResult,
            templateSelection: this.subjectDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "<div id='subjectNotFound'><p>" + comedien.i18n.eventNoMatchWithName +"</p><a href='javascript:;' id='addNewSubject' class='waves-effect waves-light btn btn-small z-depth-0'>Créer un nouveau événément</a></div>";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });

        /**
         * Triggered whenever a subject is selected in the dropdown.
         * Fetch the subject term ID and enable the submit button.
         */
        $('#event-subject').on('select2:select', function (e) {
            var id = parseInt($(this).val());
            if (id > 0) {
                self.subject.id = id;
                self.subject.name = $('#select2-event-subject-container .name').text();
                self.subject.season = $('#select2-event-subject-container .years').text();

                $btnSubmit.removeClass('disabled');
            }
        });

        /**
         * Triggered whenever a selected subject is removed.
         * Disable the submit button.
         */
        $('#event-subject').on('select2:unselect', function(e) {
            self.subject.id = 0;
            self.subject.name = '';
            self.subject.season = '';

            $btnSubmit.addClass('disabled');
        });
    },

    /**
     * Select2 template for displaying search results.
     * (for subjects)
     *
     * @param subject
     * @returns {string}
     */
    subjectDropdownTplResult: function(subject) {
        if (subject.loading) {
            return subject.text;
        }

        var name = '';
        if (typeof subject.name !== 'undefined' && subject.name != '') {
            name = subject.name;
        }

        var years = '';
        if (typeof subject.years !== 'undefined' && subject.years != '') {
            years = subject.years;
        }

        var markup = "<div class='subject'>" +
            "<span class='name'>" + name + "</span>";

        if (years) {
            markup += "<span class='years'>(" + years + ")</span>";
        }

        markup += "</div>";

        return markup;
    },

    /**
     * Select2 template for displaying the selected result.
     * (for subjects)
     *
     * @param subject
     * @returns {string}
     */
    subjectDropdownTplSelection: function(subject) {
        var output = '';

        if (subject.text) {
            output = subject.text;
        } else {
            output = "<span class='name'>" + subject.name + "</span>";
            if (typeof subject.years !== 'undefined' && subject.years != '') {
                output += "<span class='years'>" + subject.years + "</span>";
            }
        }

        return output;
    },

    /**
     * Search and select or create a new subject.
     */
    initSubjectAddNew: function() {
        var self = this;

        var $btnSubmit = $('section#subject button[type=submit]');

        /**
         * Triggered when a user want to create a new subject.
         * The new subject button is displayed only when a search returns no results.
         */
        $('body').on('click', '#addNewSubject', function() {
            var select2 = $('#event-subject').data('select2');
            var searchField = select2.$dropdown.find(".select2-search__field");
            var searchedValue = searchField.val();

            $('.select2-selection__clear').trigger('mousedown');
            $('#event-subject').select2('close');

            $('section#subject #notice_search_subject').hide();
            $('section#subject .row-select2').hide();
            $('section#subject .row-newsubject').fadeIn();
            $('section#subject .cancel').fadeIn();

            $('#newSubjectName').val(searchedValue).trigger('keyup');
            M.updateTextFields();

            $('section#subject .preloader-wrapper').css('opacity', 0);
            setTimeout(function() {
                $('section#subject .preloader-wrapper').css('opacity', 0);
            }, 500);
        });

        /**
         * Triggered when a user want to try to search a subject by name again.
         */
        $('section#subject .cancel').on('click', function() {
            $('section#subject .cancel').fadeOut();
            $('section#subject #notice_search_subject').show();
            $('section#subject .row-newsubject').hide();
            $('section#subject .row-select2').fadeIn();
            $('section#subject #newSubjectSeason').val('').removeClass('force-invalid').removeClass('force-valid');
        });

        var $inputName = $('section#subject #newSubjectName');
        var $btnSubmit = $('section#subject .first-step .btn-validate-subject');
        var typingTimer;
        var doneTypingInterval = 1500;

        $inputName.on('keyup', function () {
            $('section#subject .preloader-wrapper').css('opacity', 1);
            clearTimeout(typingTimer);
            typingTimer = setTimeout(doneTyping, doneTypingInterval);
        });

        $inputName.on('keydown', function () {
            clearTimeout(typingTimer);
        });

        /**
         * Triggered when a user is finished typing a new subject name.
         * Check if the name + season is free.
         */
        function doneTyping() {
            var value = $inputName.val();

            if (value.length >= 2) {
                if (self.lockAjaxForm) {
                    // Pending AJAX request... do nothing
                    return;
                }

                self.lockAjaxForm = true;

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'dashboard.events.search_subjects',
                        security: comedien.security,
                        name: value,
                        like: false,
                        season: $('section#subject #newSubjectSeason').val()
                    }
                }).done(function(response) {
                    if (response.success) {
                        if (response.data.length > 0) {
                            $inputName.removeClass('force-valid').addClass('force-invalid');
                            $inputName.parent().find('.error').show();
                            $btnSubmit.addClass('disabled');
                        } else {
                            $inputName.removeClass('force-invalid').addClass('force-valid');
                            $inputName.parent().find('.error').hide();
                            $btnSubmit.removeClass('disabled');
                        }
                    } else {
                        $inputName.removeClass('force-valid').addClass('force-invalid');
                        $inputName.parent().find('.error').show();
                        $btnSubmit.addClass('disabled');
                    }

                    self.lockAjaxForm = false;
                    $('section#subject .preloader-wrapper').css('opacity', 0);
                }).fail(function(jqXHR, textStatus) {
                    $inputName.removeClass('force-valid').addClass('force-invalid');
                    $btnSubmit.addClass('disabled');

                    self.lockAjaxForm = false;
                    $('section#subject .preloader-wrapper').css('opacity', 0);
                    console.log("Request failed: " + textStatus);
                });
            }
        }

        $('section#subject #newSubjectSeason').on('change', function() {
            if ($inputName.parent().find('.error').is(':visible')) {
                doneTyping();
            }
        });
    },

    /**
     * The subject has been selected or created.
     * Display the next sections.
     */
    validateSubject: function() {
        var self = this;

        $('.btn-validate-subject').on('click', function(e) {
            e.preventDefault();

            if (self.subject.id > 0) {
                // The subject already exist and was selected by the user
                // We can access the self.subject object

                self.getEventsWithSubject();
            } else if ($('section#subject #newSubjectName').val() != '') {
                // The new subject must be created
                self.subject.name = $('section#subject #newSubjectName').val();
                self.subject.season = $('section#subject #newSubjectSeason').val();
            }

            $('section#subject .first-step').hide();
            $('section#subject .second-step').fadeIn();

            $('section#subject #subjectReminder').val(self.subject.name + " (" + self.subject.season + ")");

            $('section.hide-on-load').fadeIn(500, function() {
                self.updateContainerHeight();
            });

            $('.section-actions.bottom').show();
            $('.section-actions .fake-submit').removeClass('disabled');
        });
    },

    /**
     * If the user has selected an existing subject: we need to check if there is any events linked to this subject,
     * and if these events could be "shared" (see the meta key "allow-data-sharing"). If so, display a dropdown menu
     * to the user allowing him to eventually select a event to "copy" (=> auto-populate fields).
     */
    getEventsWithSubject: function() {
        var self = this;

        if (self.lockAjaxForm) {
            // Pending AJAX request... wait
            return;
        }

        self.lockAjaxForm = true;

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: "idSubject=" + self.subject.id + "&action=dashboard.events.search_shareable_events&security=" + comedien.security,
        }).done(function(response) {
            if (response.success) {
                if (response.data.length > 0) {
                    var dropdown = $('.input-field-select-shareable select');

                    // Inset new options to the dropdown
                    $.each(response.data, function (i, item) {
                        var title = item.title;
                        if (item.placeTitle != '') {
                            title += " - " + item.placeTitle;
                            if (item.placeCity != '') {
                                title += " (" + item.placeCity + ")";
                            }
                        }

                        dropdown.append($('<option>', {
                            value: item.id,
                            text : title
                        }));
                    });

                    dropdown.formSelect();

                    $('#subject .shareable').fadeIn();

                    self.updateContainerHeight();
                }
            } else {
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            }

            self.lockAjaxForm = false;
        }).fail(function(jqXHR, textStatus) {
            self.lockAjaxForm = false;
            console.log("Request failed: " + textStatus);
           M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
        });

        $('.input-field-select-shareable').on('change', 'select', function() {
            var idEvent = parseInt($(this).val());

            if (idEvent > 0) {
                self.autopopulateFieldsFromShareableEvent(idEvent);
            }
        });
    },

    /**
     * If the user has selected a existing (and shareable) event, autopopulate the fields.
     *
     * @param idEvent
     */
    autopopulateFieldsFromShareableEvent: function(idEvent) {
        var self = this;

        if (self.lockAjaxAutopopulate) {
            // Pending AJAX request... wait
            return;
        }

        self.lockAjaxAutopopulate = true;

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: "idEvent=" + idEvent + "&action=dashboard.events.autopopulate_from_shareable_event&security=" + comedien.security + "&isUpdate=" + self.isUpdate,
        }).done(function(response) {
            if (response.success) {
                $.each(response.data, function (key, value) {
                    switch (key) {
                        case 'idCategory':
                            $('#infos #category').val(value);
                            $('#infos #category').formSelect();
                            break;
                        case 'place':
                            // If not empty, set initial value with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127
                            if (Object.keys(value).length > 0) {
                                var optionText = self.placeDropdownTplResult(value);
                                var $option = $("<option selected></option>").val(value.id).text(optionText);
                                self.select2Place.append($option).trigger('change').trigger('select2:select');
                            }
                            break;
                        case 'place-opening-hours-booking':
                            if (value.length > 0) {
                                self.customPlaceOpeningHours = true;

                                var textareaPlaceOpeningHours = $('#place-opening-hours-booking');
                                var checkboxEditPlaceOpeningHours = $('#change-place-opening-hours-booking');

                                textareaPlaceOpeningHours.prop('disabled', false);
                                textareaPlaceOpeningHours.text(self.decodeHtml(value));

                                $('#row-place-opening-hours-booking').fadeIn();
                                checkboxEditPlaceOpeningHours.prop('checked', true);

                                self.updateContainerHeight();
                            }
                            break;
                        case 'place-phone-booking':
                            if (value.length > 0) {
                                self.customPlaceOpeningHours = true;

                                var inputPlacePhoneBooking = $('#place-phone-booking');
                                var checkboxEditPlacePhoneBooking = $('#change-place-phone-booking');

                                inputPlacePhoneBooking.prop('disabled', false);
                                inputPlacePhoneBooking.intlTelInput('setNumber', value);

                                $('#row-place-phone-booking').fadeIn();
                                checkboxEditPlacePhoneBooking.prop('checked', true);

                                self.updateContainerHeight();
                            }
                            break;
                        // Actors
                        case 'casting-actors':
                            // Set multiple initial values with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127

                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor.id).text(actor.name);
                                self.select2Actor.append($option);
                            });

                            self.select2Actor.trigger('change');
                            break;
                        // Actors (free text)
                        case 'casting-actors-other':
                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor).text(actor);
                                self.select2Actor.append($option);
                            });
                            break;
                        // Casting directing
                        case 'casting-directing':
                            // Set multiple initial values with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127

                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor.id).text(actor.name);
                                self.select2CastingDirecting.append($option);
                            });

                            self.select2CastingDirecting.trigger('change');
                            break;
                        // Casting directing (free text)
                        case 'casting-directing-other':
                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor).text(actor);
                                self.select2CastingDirecting.append($option);
                            });
                            break;
                        // Casting directing assistantship
                        case 'casting-directing-assistantship':
                            // Set multiple initial values with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127

                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor.id).text(actor.name);
                                self.select2CastingDirectingAssistantship.append($option);
                            });

                            self.select2CastingDirectingAssistantship.trigger('change');
                            break;
                        // Casting directing assistantship (free text)
                        case 'casting-directing-assistantship-other':
                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor).text(actor);
                                self.select2CastingDirectingAssistantship.append($option);
                            });
                            break;
                        // Casting author
                        case 'casting-author':
                            // Set multiple initial values with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127

                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor.id).text(actor.name);
                                self.select2CastingAuthor.append($option);
                            });

                            self.select2CastingAuthor.trigger('change');
                            break;
                        // Casting author (free text)
                        case 'casting-author-other':
                            $.each(value, function (k, actor) {
                                var $option = $("<option selected></option>").val(actor).text(actor);
                                self.select2CastingAuthor.append($option);
                            });
                            break;
                        // Casting compagnies
                        case 'casting-compagnies':
                            // Set multiple initial values with select2 (and a AJAX data source)
                            // @link http://stackoverflow.com/a/30328989/1123127

                            $.each(value, function (k, place) {
                                var $option = $("<option selected></option>").val(place.id).text(place.name);
                                self.select2CastingCompagnies.append($option);
                            });

                            self.select2CastingCompagnies.trigger('change');
                            break;
                        // Casting compagnies (free text)
                        case 'casting-compagnies-other':
                            $.each(value, function (k, place) {
                                var $option = $("<option selected></option>").val(place).text(place);
                                self.select2CastingCompagnies.append($option);
                            });
                            break;
                        // Textarea
                        case 'description':
                            $('#infos #description').val(value).trigger('autoresize');
                            break;
                        // Input text
                        case 'duration':
                        case 'price':
                        case 'casting-light':
                        case 'casting-dramaturgie':
                        case 'casting-film-maker':
                        case 'casting-stage-design':
                        case 'casting-photography':
                        case 'casting-scenery':
                        case 'casting-costume-designer':
                        case 'casting-music':
                        case 'casting-music-direction':
                        case 'casting-technical':
                        case 'casting-choreography':
                        case 'casting-sound':
                        case 'casting-video':
                        case 'casting-administration':
                        case 'casting-coproduction':
                        case 'casting-soutiens':
                        case 'casting-postproduction':
                        case 'casting-production':
                            var input = $('.input-field #' + key);
                            if (input.length > 0) {
                                input.val(value);
                                input.parent().find('label').addClass('active');
                            }
                            break;
                        // Radio button
                        case 'interval':
                            if (value) {
                                $('#interval-yes').attr('checked', 'checked');
                            } else {
                                $('#interval-no').attr('checked', 'checked');
                            }
                            break;
                        // Shows
                        case 'shows':
                            var i = 0;
                            $.each(value, function (k, show) {
                                var nbShow = $('#shows .row-show').length;
                                // if (i > 0) {
                                    $('#shows').append(self.addShowRow());
                                    $.fn.matchHeight._update();
                                    // console.log(show)
                                    // Date picker

                                    var datePicker = $('#shows #shows-' + nbShow + '-date').datepicker(self.getShowPickadateConfig(nbShow));
                                    // console.log(datePicker)
                                    self.showsDatePickers.push(datePicker);


                                    // var picker = datePicker.pickadate('picker');
                                    // picker.set('select', show.date, { format: 'yyyy-mm-dd' });
                                    $('#shows #show-' + nbShow + '-date').val(show.date);

                                    var date = show.date.split("-");
                                    var day = date[2];
                                    var monthIndex = date[1];
                                    var year = date[0];

                                    var datetime = day + '.' + monthIndex + '.' + year;
                                    $('#shows #shows-' + nbShow + '-date').val(datetime)


                                    var currentDate = new Date(year, monthIndex - 1, day);
                                    $('#shows #shows-' + nbShow + '-date').datepicker("gotoDate", currentDate)

                                    // Time picker

                                    var timePicker = $('#shows #shows-' + nbShow + '-hour').timepicker(self.getShowTimepickerConfig());
                                    self.showsTimePickers.push(timePicker);
                                    $('#shows #shows-' + nbShow + '-hour').val(show.hour);
                                /*} else {
                                    // TODO: Check this functionality
                                    var datePicker = $('#shows #shows-' + 0 + '-date').datepicker(self.getShowPickadateConfig(0));
                                    console.log(datePicker)
                                    // var picker = datePicker.pickadate('picker');
                                    // picker.set('select', show.date, { format: 'yyyy-mm-dd' });
                                    // $('#course-start-date').datepicker('setDate', $('#course-start-date').val());
                                    $('#shows #show-' + 0 + '-date').val(show.date);
                                    $('#shows #shows-0-hour').val(show.hour);
                                    $('#shows .row-show').first().show();

                                }*/
                                i++;
                            });
                            break;
                    }
                });

                if (!self.isUpdate) {
                    $('section#images .col-copy-featured-image').fadeIn();
                }

                setTimeout(function() {
                    self.updateContainerHeight();
                }, 250)
            } else {
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            }

            self.lockAjaxAutopopulate = false;
        }).fail(function(jqXHR, textStatus) {
            self.lockAjaxAutopopulate = false;
            console.log("Request failed: " + textStatus);
           M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
        });
    },

    copyFeaturedImage: function() {
        var self = this;

        $('section#images').on('change', '#copyFeaturedImage', function() {
            if ($(this).is(":checked")) {

                if (self.lockAjaxCopyFeaturedImage) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxCopyFeaturedImage = true;

                $('#copyFeaturedImage').attr('disabled', 'disabled');

                var idEvent = $('.input-field-select-shareable select').val();

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "idEvent=" + idEvent + "&action=dashboard.events.get_featured_image_for_copy&security=" + comedien.security,
                }).done(function(response) {
                    if (response.success) {
                        $('section#images .col-copy-featured-image').hide();

                        // Displsy the thumbnail of the featured image

                        var preview = '<div id="preview-' + response.data.idAttachment + '" class="col s4 col-image ui-state-default">' +
                            '<div class="inner"><img src="' + response.data.urlAttachment + '" alt="" title="" /></div>' +
                            '</div>';

                        $('#images .col-preview .row-images').prepend(preview);
                        $('#images .col-preview').show();

                        $('#event-form #idImages').val(response.data.idAttachment);

                        // Show or hide field to upload other images

                        if (self.maxImages == 1) {
                            // Max number of images reached: hide the
                            $('#images #image-1').parents('.file-field').hide();
                            $('#images .col-add').hide();
                        } else {
                            $('#images .btn-add').trigger('click');
                            $('#images #image-1').parents('.file-field').hide();
                        }
                    } else {
                        $('#copyFeaturedImage').attr('disabled', false).attr('checked', false);
                    }

                    self.lockAjaxCopyFeaturedImage = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxCopyFeaturedImage = false;
                    $('#copyFeaturedImage').attr('disabled', false).attr('checked', false);
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                });
            }
        });
    },

    /**
     * Display places with a select2 dropdown.
     */
    initPlaceDropdown: function() {
        var self = this;

        var textareaPlaceOpeningHours = $('#place-opening-hours-booking');
        var checkboxEditPlaceOpeningHours = $('#change-place-opening-hours-booking');

        var inputPlacePhoneBooking = $('#place-phone-booking');
        var checkboxEditPlacePhoneBooking = $('#change-place-phone-booking');
        var labelPlacePhoneBooking = $('label[for="place-phone-booking"]');
   
        this.select2Place = $('section#infos-place #place').select2({
            placeholder: "Lieu de représentation",
            allowClear: true,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_place',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    return {
                        results: selectData.data,
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.placeDropdownTplResult,
            templateSelection: this.placeDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "<div id='placeNotFound'><p>" + comedien.i18n.placeNoMatchWithName +"</p><a href='javascript:;' id='addNewPlace' class='waves-effect waves-light btn btn-small z-depth-0'>Créer un nouveau lieu</a></div>";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });

        /**
         * Triggered whenever a place is selected in the dropdown.
         */
        $('section#infos-place #place').on('select2:select', function (e) {
            var idPlace = parseInt($(this).val());

            if (idPlace > 0) {
                if (self.isUpdate) {
                    if (self.customPlaceOpeningHours == true) {
                        return;
                    }
                }

                // TODO
                $('.input-field-other-place').hide();

                if (self.lockAjaxForm) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxForm = true;

                // Custom place opening hours

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "action=dashboard.events.get_place_opening_hours_booking&security=" + comedien.security + "&idPlace=" + idPlace,
                }).done(function(response) {
                    $('#row-place-opening-hours-booking').fadeOut();
                    textareaPlaceOpeningHours.text('');
                    checkboxEditPlaceOpeningHours.prop('checked', false);

                    if (response.success) {
                        if (response.data.length > 0) {
                            textareaPlaceOpeningHours.text(response.data);
                            $('#row-place-opening-hours-booking').fadeIn();
                        }
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                        $('#row-place-opening-hours-booking').fadeOut();
                        textareaPlaceOpeningHours.text('');
                        checkboxEditPlaceOpeningHours.prop('checked', false);
                    }

                    self.updateContainerHeight();

                    self.lockAjaxForm = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxForm = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                    $('#row-place-opening-hours-booking').fadeOut();
                    textareaPlaceOpeningHours.text('');
                    checkboxEditPlaceOpeningHours.prop('checked', false);

                    self.updateContainerHeight();
                });

                // Custom place phone booking

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "action=dashboard.events.get_place_phone_booking&security=" + comedien.security + "&idPlace=" + idPlace,
                }).done(function(response) {
                    $('#row-place-phone-booking').fadeOut();
                    inputPlacePhoneBooking.val('');
                    labelPlacePhoneBooking.css('color', 'rgba(0,0,0,.26)');
                    checkboxEditPlacePhoneBooking.prop('checked', false);

                    if (response.success) {
                        //if (response.data.length > 0) {
                            inputPlacePhoneBooking.val(response.data);
                            inputPlacePhoneBooking.intlTelInput('setNumber', response.data);
                            $('#row-place-phone-booking').fadeIn();
                        //}
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                        $('#row-place-phone-booking').fadeOut();
                        inputPlacePhoneBooking.val('');
                        checkboxEditPlacePhoneBooking.prop('checked', false);
                    }

                    self.updateContainerHeight();

                    self.lockAjaxForm = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxForm = false;
                    console.log("Request failed: " + textStatus);
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);

                    $('#row-place-phone-booking').fadeOut();
                    inputPlacePhoneBooking.val('');
                    checkboxEditPlacePhoneBooking.prop('checked', false);

                    self.updateContainerHeight();
                });
            }
        });

        /**
         * Triggered whenever a selected place is removed.
         */
        $('section#infos-place #place').on('select2:unselect', function(e) {
            textareaPlaceOpeningHours.text('');
            checkboxEditPlaceOpeningHours.prop('checked', false);
            checkboxEditPlacePhoneBooking.prop('checked', false);

            // TODO
            $('.input-field-other-place').show();

            self.updateContainerHeight();
        });

        /**
         * Triggered whenever the user want to specify a custom opening hours for the selected place.
         */
        checkboxEditPlaceOpeningHours.on('change', function() {
            if ($(this).is(":checked")) {
                textareaPlaceOpeningHours.prop('disabled', false);
            } else {
                textareaPlaceOpeningHours.attr('disabled', 'disabled');
            }
        });

        /**
         * Triggered whenever the user want to specify a custom phone booking for the selected place.
         */
        checkboxEditPlacePhoneBooking.on('change', function() {
            if ($(this).is(":checked")) {
                inputPlacePhoneBooking.prop('disabled', false);
                labelPlacePhoneBooking.css('color', '');
            } else {
                inputPlacePhoneBooking.attr('disabled', 'disabled');
                labelPlacePhoneBooking.css('color', 'rgba(0,0,0,.26)');
            }
        });
    },

    initPlaceOther: function() {
        var self = this;

        /**
         * Triggered when a user want to create a new place.
         * The new place button is displayed only when a search returns no results.
         */
        $('body').on('click', '#addNewPlace', function(e) {
            e.preventDefault();

            var idSubject = self.subject.id; // bug fix

            var select2 = $('section#infos-place #place').data('select2');
            var searchField = select2.$dropdown.find(".select2-search__field");
            var searchedValue = searchField.val();

            $('.select2-selection__clear').trigger('mousedown');
            $('section#infos-place #place').select2('close');
            $('.select2-container--open').remove();
            $('section#infos-place .row-select2').hide();
            $('section#infos-place .new-place').fadeIn().addClass('open');
            $('section#infos-place #other-place-title').val(searchedValue).trigger('keyup');

            M.updateTextFields();

            self.subject.id = idSubject; // bug fix
        });

        /**
         * Triggered when a user want to try to search a place by name again.
         */
        $('section#infos-place .btn-cancel').on('click', function(e) {
            e.preventDefault();

            $('section#infos-place .new-place').fadeOut().removeClass('open');
            $('section#infos-place .row-select2').fadeIn();

            $('section#infos-place #other-place-title').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-address-street').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-address-street-more').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-address-postal-code').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-address-city').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-address-country').prop('selectedIndex', 0);
            $('section#infos-place #other-place-address-canton').prop('selectedIndex', 0);
            $('section#infos-place #other-place-phone').val('').removeClass('invalid').removeClass('valid');
            $('section#infos-place #other-place-phone-int').val('');
            $('section#infos-place #other-place-website').val('').removeClass('invalid').removeClass('valid');
        });

        // International Telephone Input
        // translated in french with the help of @link https://github.com/harold-s/harold-s/tree/master/intl-tel-input-french-translation
        var countryData = $.fn.intlTelInput.getCountryData();

        $.each(countryData, function(i, country) {
            country.name = helpers.hashCountryDataTranslation[country.iso2];
        });

        $('.input-field .phone').each(function() {
            $(this).intlTelInput({
                autoPlaceholder: 'polite',
                utilsScript: comedien.assets + 'vendor/intl-tel-input/build/js/utils.js',
                initialCountry: 'ch',
                preferredCountries: ['ch', 'fr', 'be', 'de', 'it']
            });
        });

        // On page load, show or hide the 'other place' fields

        if (this.isUpdate) {
            var idPlace = parseInt($('section#infos-place #place').data('current-place'));

            if (idPlace == '' || isNaN(idPlace) || idPlace == 0) {
                // No place selected by the user, so it must be a 'other place'.

                $('section#infos-place .row-select2').hide();
                $('section#infos-place .new-place').fadeIn().addClass('open');
            }
        }
    },

    /**
     * Select2 template for displaying search results.
     * (for places)
     *
     * @param place
     * @returns {string}
     */
    placeDropdownTplResult: function(place) {
        if (place.loading) {
            return place.text;
        }

        var name = '';
        if (typeof place.name !== 'undefined' && place.name != '') {
            name = place.name;
        }

        var city = '';
        if (typeof place.city !== 'undefined' && place.city != '') {
            city = place.city;
        }

        var markup = "<div class='place'>" +
            "<span class='name'>" + name + "</span>";

        if (city) {
            markup += "<span class='city'>(" + city + ")</span>";
        }

        markup += "</div>";

        return markup;
    },

    /**
     * Select2 template for displaying the selected result.
     * (for places)
     *
     * @param place
     * @returns {string}
     */
    placeDropdownTplSelection: function(place) {
        var output = '';

        if (place.text) {
            output = place.text;
        } else {
            output = "<span class='name'>" + place.name + "</span>";
            if (typeof place.city !== 'undefined' && place.city != '') {
                output += "<span class='city'>(" + place.city + ")</span>";
            }
        }

        return output;
    },

    /**
     * Display actors with a select2 dropdown.
     */
    initActorsDropdown: function() {
        this.select2Actor = $('section#distribution #actors').select2({
            placeholder: "",
            tags: true,
            tokenSeparators: [','],
            allowClear: true,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_actors',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    $('#countSelect2ActorsResults').val(selectData.data.length);

                    return {
                        results: selectData.data
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.actorsDropdownTplResult,
            templateSelection: this.actorsDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "Aucun comédien correspond à votre recherche";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });
    },

    /**
     * Autocompelte by actors.
     */
    initActorsAutocomplete: function() {
        // Directors
        this.select2CastingDirecting = $('section#distribution #casting-directing').select2({
            placeholder: "Saisir / sélectionner",
            tags: true,
            tokenSeparators: [','],
            allowClear: false,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_actors',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    $('#countSelect2ActorsResults').val(selectData.data.length);

                    return {
                        results: selectData.data
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.actorsAutocompleteTplResult,
            templateSelection: this.actorsDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "Aucune personne ne correspond à votre recherche";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });

        // Directors assistantship
        this.select2CastingDirectingAssistantship = $('section#distribution #casting-directing-assistantship').select2({
            placeholder: "Saisir / sélectionner",
            tags: true,
            tokenSeparators: [','],
            allowClear: false,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_actors',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    $('#countSelect2ActorsResults').val(selectData.data.length);

                    return {
                        results: selectData.data
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.actorsAutocompleteTplResult,
            templateSelection: this.actorsDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "Aucune personne ne correspond à votre recherche";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });

        // Author
        this.select2CastingAuthor = $('section#distribution #casting-author').select2({
            placeholder: "Saisir / sélectionner",
            tags: true,
            tokenSeparators: [','],
            allowClear: false,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_actors',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    $('#countSelect2ActorsResults').val(selectData.data.length);

                    return {
                        results: selectData.data
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.actorsAutocompleteTplResult,
            templateSelection: this.actorsDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "Aucune personne ne correspond à votre recherche";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });
    },

    /**
     * Aucomplete by compagnies.
     */
    initPlacesAutocomplete: function() {
        // Compagnies
        this.select2CastingCompagnies = $('section#distribution #casting-compagnies').select2({
            placeholder: "Saisir / sélectionner",
            tags: true,
            tokenSeparators: [','],
            allowClear: false,
            ajax: {
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        action: 'dashboard.events.search_compagnies',
                        security: comedien.security,
                        name: params.term,
                    };
                },
                processResults: function (selectData, params) {
                    $('#countSelect2CompagniesResults').val(selectData.data.length);

                    return {
                        results: selectData.data
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) { return markup; },
            templateResult: this.placesAutocompleteTplResult,
            templateSelection: this.placesDropdownTplSelection,
            'language': {
                'noResults': function() {
                    return "Aucune compagnie ne correspond à votre recherche";
                },
                'inputTooShort': function(){
                    return "Taper au moins 2 caractères";
                },
                'searching': function() {
                    return comedien.i18n.select2Searching;
                },
                'errorLoading': function() {
                    return comedien.i18n.select2Searching;
                    //return comedien.i18n.select2ErrorLoading;
                },
            },
        });
    },

    /**
     * Select2 template for displaying search results.
     * (for actors)
     *
     * @param actor
     * @returns {string}
     */
    actorsDropdownTplResult: function(actor) {
        var countTotal = parseInt($('#countSelect2ActorsResults').val());

        if (actor.loading) {
            return actor.text;
        }

        var name = '';
        if (typeof actor.name !== 'undefined' && actor.name != '') {
            name = actor.name;
            return "<span class='name'>" + name + "</span>";
        } else if (countTotal == 0) {
            name = 'Si vous ne trouvez pas le comédien dans la liste ci-dessous, vous pouvez l\'ajouter en cliquant sur ce message';
            return "<span class='name noResult'>" + name + "</span>";
        }
    },

    /**
     * Select2 template for displaying search results.
     * (for actors - autocomplete)
     *
     * @param actor
     * @returns {string}
     */
    actorsAutocompleteTplResult: function(actor) {
        var countTotal = parseInt($('#countSelect2ActorsResults').val());

        if (actor.loading) {
            return actor.text;
        }

        var name = '';
        if (typeof actor.name !== 'undefined' && actor.name != '') {
            name = actor.name;
            return "<span class='name'>" + name + "</span>";
        } else if (countTotal == 0) {
            name = 'La personne que vous recherchez n\'est pas dans cette liste ? Ajoutez-là en cliquant sur ce message.';
            return "<span class='name noResult'>" + name + "</span>";
        }
    },

    /**
     * Select2 template for displaying the selected result.
     * (for actors)
     *
     * @param actor
     * @returns {string}
     */
    actorsDropdownTplSelection: function(actor) {
        var output = '';

        if (actor.text) {
            output = actor.text;
        } else {
            output = "<span class='name'>" + actor.name + "</span>";
        }

        return output;
    },

    /**
     * Select2 template for displaying search results.
     * (for compagnies - autocomplete)
     *
     * @param actor
     * @returns {string}
     */
    placesAutocompleteTplResult: function(place) {
        var countTotal = parseInt($('#countSelect2CompagniesResults').val());

        if (place.loading) {
            return place.text;
        }

        var name = '';
        if (typeof place.title !== 'undefined' && place.title != '') {
            name = place.title;
            return "<span class='name'>" + name + "</span>";
        } else if (countTotal == 0) {
            name = 'La compagnie que vous recherchez n\'est pas dans cette liste ? Ajoutez-là en cliquant sur ce message.';
            return "<span class='name noResult'>" + name + "</span>";
        }
    },

    /**
     * Select2 template for displaying the selected result.
     * (for compagnies)
     *
     * @param place
     * @returns {string}
     */
    placesDropdownTplSelection: function(place) {
        var output = '';

        if (place.text) {
            output = place.text;
        } else {
            output = "<span class='name'>" + place.title + "</span>";
        }

        return output;
    },

    onCategoryChange: function() {
        $('#infos #category').change(function() {
            if ($(this).find(':selected').data('slug') == 'cinema') {
                $('#distribution').find('.cinema').removeClass('hidden');
                $('#distribution').find('.no-cinema').addClass('hidden');
            } else {
                $('#distribution').find('.cinema').addClass('hidden');
                $('#distribution').find('.no-cinema').removeClass('hidden');
            }
        });
    },

    initShows: function() {
        var self = this;

        // Initial inputs

        var datePicker = $('#shows #shows-0-date').datepicker(self.getShowPickadateConfig(0));
        self.showsDatePickers.push(datePicker);

        var timePicker = $('#shows #shows-0-hour').timepicker(self.getShowTimepickerConfig());
        self.showsTimePickers.push(timePicker);

        // Add a new row

        $('.btn-add-show').on('click', function() {
            var nbShow = $('#shows .row-show').length;

            if (nbShow == 1 && $('#shows .row-show').first().css('display') == 'none') {
                $('#shows .row-show').first().show();
            } else {
                $('#shows').append(self.addShowRow());
                $.fn.matchHeight._update();

                var datePicker = $('#shows #shows-' + nbShow + '-date').datepicker(self.getShowPickadateConfig(nbShow));
                self.showsDatePickers.push(datePicker);

                var timePicker = $('#shows #shows-' + nbShow + '-hour').timepicker(self.getShowTimepickerConfig());
                self.showsTimePickers.push(timePicker);
            }
        });

        // Add a range of new row

        $('.btn-add-show-range').on('click', function(e) {
            e.preventDefault();

            $('#intervalModal').modal('open');
        });

        $('#intervalModal .btn-validate').on('click', function(e) {
            e.preventDefault();

            var $inputDateStart = $('#intervalModal #date-start');
            var $inputDateEnd = $('#intervalModal #date-end');

            $inputDateStart.removeClass('invalid');
            $inputDateEnd.removeClass('invalid');

            if ($inputDateStart.val() == '') {
                $inputDateStart.addClass('invalid');
            }
            if ($inputDateEnd.val() == '') {
                $inputDateEnd.addClass('invalid');
            }

            if ($inputDateStart.val() == '' || $inputDateEnd.val() == '') {
                return false;
            }

            // The user has selected a start and end date

            var startDate = $('#event-form #whenIntervalStart').val() + ' 00:00:00';
            var endDate = $('#event-form #whenIntervalEnd').val() + ' 00:00:00';

            // Get the number of days between the start and end date

            var objStartDate = helpers.getDateObjFromDatetime(startDate);
            var objEndDate = helpers.getDateObjFromDatetime(endDate);
            var daysBetween = helpers.getDaysBetweenDates(objStartDate, objEndDate) + 1;

            // Create a new row for each day between the date interval

            var pickaDateConfig = self.getShowPickadateConfig();
            var timePickerConfig = self.getShowTimepickerConfig();

            for (var i = 0; i < daysBetween; i++) {
                var nbShow = $('#shows .row-show').length;

                if (nbShow == 1 && $('#shows .row-show').first().css('display') == 'none') {
                    $('#shows .row-show').first().show();
                    nbShow = 0;
                } else {
                    $('#shows').append(self.addShowRow());
                }

                if (i > 0) {
                    // +1 day
                    objStartDate.setTime(objStartDate.getTime() + 1 * 86400000);
                }

                // We need to get the date in the swiss format (dd.mm.YYYY) to pre-fill the input value
                // (following the 'format' parameter of the PickaDate config)
                var swissDate = helpers.getSwissDateStrFromDateObj(objStartDate); // dd.mm.YYYY
                var normalDate = helpers.getDateStringFromDateObj(objStartDate); // YYYY-mm-dd

                var datePicker = $('#shows #shows-' + nbShow + '-date').val(swissDate).datepicker(pickaDateConfig);

                self.showsDatePickers.push(datePicker);

                $('#shows #show-' + nbShow + '-date').val(normalDate).datepicker(pickaDateConfig);

                if (nbShow == 0) {
                    // Bug fix
                    $('#shows input[name="shows[0][date]_submit"]').val(helpers.getDatetimeFromDateObj(objStartDate));
                }

                var timePicker = $('#shows #shows-' + nbShow + '-hour').timepicker(timePickerConfig);

                self.showsTimePickers.push(timePicker);
            }

            // Update UI

            $.fn.matchHeight._update();
            M.updateTextFields();

            // Reset the inputs and close the modal window

            $('#event-form #whenIntervalStart').val('');
            $('#event-form #whenIntervalEnd').val('');
            $('#intervalModal #date-start').val('');
            $('#intervalModal #date-end').val('');

            $('#intervalModal').modal('close');

            return true;
        });

        this.createIntervalDatepicker('.interval', '#site-header')
    },

    createIntervalDatepicker: function (selector, pickaDateContainer, minDate) {
        if (minDate === null) {
            minDate = new Date()
        }


        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        var self = this;
        $(selector).datepicker({
            container: pickaDateContainer,
            format: 'dd.mm.yyyy',
            minDate: minDate,
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays: weekdaysFull,
                months: monthsFull
            },
            onSelect: function(date) {
                // console.log(date)
            },
            onDraw: function() {
                // console.log(this)
            },
            onOpen: function() {
                var startDate = $('#'+ self.searchFormName +' #whenIntervalStart').val();
                if (this.$el[0].id === 'date-end' && startDate === '') {
                    this.close();
                } else {
                    $('#intervalModal').modal('close');
                }
            },
            onClose: function () {
                // Get the value
                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }
                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (this.$el[0].id === 'date-start') {
                        $('#event-form #whenIntervalStart').val(datetime);
                        $('#date-end').datepicker('destroy');
                        self.createIntervalDatepicker('#date-end', pickaDateContainer, this.date)
                    } else if (this.$el[0].id === 'date-end') {
                        $('#event-form #whenIntervalEnd').val(datetime);
                    }
                }
                $('#intervalModal').modal('open');
                $('.interval').blur();
                $(document.activeElement).blur();

                $('html, body').animate({
                    scrollTop: $('section#shows').offset().top - $('#site-header').height()
                }, 0);
            },
        });
    },

    getShowPickadateConfig: function(index) {

        var minDate = undefined;
        if (!this.isUpdate) {
            minDate = new Date();
        }

        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        return {
            container: '#site-header',
            format: 'dd.mm.yyyy',
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            minDate: minDate,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onClose: function () {

                if (typeof this.date === 'undefined')
                    return;

                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }
                if (day < 10) {
                    day = '0'+day;
                }
                if (index === null) {
                    return;
                }
                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('#shows #show-' + index + '-date').val(datetime);
                        $('#shows #shows-' + index + '-date').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('#shows #show-' + index + '-date').val('');
                        $('#shows #shows-' + index + '-date').removeClass('force-valid').addClass('force-invalid');
                    }
                } else {
                    $('#shows #show-' + index + '-date').val('');
                    $('#shows #shows-' + index + '-date').removeClass('force-valid').addClass('force-invalid');
                }
            }
        };
    },

    getShowTimepickerConfig: function() {
        return {
            'twelveHour': false,
            'timeFormat': 'H\\hi',
            'step': 15,
            'disableTimeRanges': [
                ['12:00am', '5:00am']
            ]
        };
    },

    addShowRow: function() {
        var nbShow = $('#shows .row-show').length;

        var html =
            '<div class="row row-show">' +
            '<div class="input-field col s6">' +
            '<input id="show-' + nbShow + '-date" name="shows[' + nbShow + '][date]" type="hidden">' +
            '<input id="shows-' + nbShow + '-date" type="text" class="date">' +
            '<label for="shows-' + nbShow + '-date">Date de représentation</label>' +
            '</div>' +
            '<div class="input-field col s6">' +
            '<input id="shows-' + nbShow + '-hour" name="shows[' + nbShow + '][hour]" type="text" class="time" pattern="([01]?[0-9]|2[0-3])(h)[0-5][0-9]">' +
            '<label for="shows-' + nbShow + '-hour">Heure de début</label>' +
            '</div>' +
            '<a href="javascript:;" class="remove-show" title="Supprimer cette date"><i class="material-icons">delete_forever</i></a>' +
            '</div>';

        return html;
    },

    removeShowRow: function() {
        $(document).on('click', '.remove-show', function(e) {
            e.preventDefault();
            $(this).parent().remove();
        });
    },

    /**
     * Submit the form to create the event.
     */
    submitForm: function() {
        var self = this;
        var form = $('#event-form');
        var btnSubmit = $('.section-actions .fake-submit');
        var spinner = $('.section-actions .preloader-wrapper');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            btnSubmit.addClass('disabled');
            spinner.css('display', 'inline-block').css('opacity', 1);
            $('.invalid', form).removeClass('invalid');

            var ajaxAction = 'dashboard.events.create';
            if (self.isUpdate) {
                ajaxAction = 'dashboard.events.update'
            }

            var intlNumber = $('#infos-place #other-place-phone').intlTelInput('getNumber');
            $('#infos-place #other-place-phone-int').val(intlNumber);

            var intlNumberPlaceBooking = $('#place-phone-booking').intlTelInput('getNumber');
            $('#place-phone-booking-intl').val(intlNumberPlaceBooking);

            var formdata = false;
            if (window.FormData) {
                formdata = new FormData(form[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);

                if (!self.isUpdate) {
                    formdata.append('idSubject', self.subject.id);
                    formdata.append('nameSubject', self.subject.name);
                    formdata.append('seasonSubject', self.subject.season);
                }

                // Bug fix Safari 11 / Webkit
                // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
                // @link https://trac.webkit.org/changeset/230963/webkit
                $("input[type=file]", form).each(function () {
                    if ($(this).val() === "") {
                        formdata.delete($(this).attr("name"));
                    }
                });
            }

            var dataSerialized = form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security;
            if (!self.isUpdate) {
                dataSerialized = dataSerialized + "&idSubject=" + self.subject.id + "&nameSubject=" + self.subject.name + "&seasonSubject=" + self.subject.season;
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : dataSerialized,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    var redirectDelay = 5000;

                    if (self.isUpdate) {
                        M.toast({html:'<span>'+ comedien.i18n.eventSuccessfullyUpdated +'</span>'}, redirectDelay);
                    } else {
                        redirectDelay = 10000;
                        $('#modal-dashboard-event-created').modal('open');
                    }

                    setTimeout(function() {
                        var url = $('#redirectTo', form).val();
                        location.replace(url);
                    }, redirectDelay);
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, form).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                            if (i == 'actors' || i == 'casting-directing' || i == 'casting-directing-assistantship' || i == 'casting-author' || i == 'casting-compagnies' || i == 'place') {
                                $('#' + i, form).parent().find('.select2-container').addClass('invalid');
                            }
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    btnSubmit.removeClass('disabled');
                }

                self.lockAjaxForm = false;
                spinner.css('opacity', 0).css('display', 'none');
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
                btnSubmit.removeClass('disabled');
                spinner.css('opacity', 0).css('display', 'none');
                M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        btnSubmit.on('click', function() {
            if (self.isUpdate) {
                // Prepare hidden input for images order

                var idImages = '';
                $('section#images .row-images .col-image').each(function(index, element) {
                    idImages += $(this).data('attachment-id') + ',';
                });
                idImages = idImages.replace(/,\s*$/, "");
                $('#event-form #idImages').val(idImages);
            }

            // Pre-validate form
            var result = self.validateFormBeforeSubmit();

            if (result) {
                $('#event-form').submit();
            }
        });

        $('#modal-dashboard-event-created').modal({
            dismissible: false,
        });
    },

    /**
     * Validate the form before submit it.
     *
     * @returns {boolean}
     */
    validateFormBeforeSubmit: function() {
        if ($('section#images .row-images .col-image').length == 0) {
            if ($('#image-1').get(0).files.length === 0) {
                M.toast({html:'<span>'+ comedien.i18n.eventFeaturedImageRequired +'</span>'}, 5000);
                return false;
            }
        }

        return true;
    },

    /**
     * Allow the user to update the event name (on edit form).
     */
    updateEventName: function() {
        $('section#subject #change-event-name').on('change', function() {
            if ($(this).is(':checked')) {
                $('section#subject .edit-step .input-field-input').show();
            } else {
                $('section#subject .edit-step .input-field-input').hide();
            }
        });

        if ($('#allow-data-sharing-yes').is(":checked")) {
            $('section#subject .notice-data-sharing').show();
        } else {
            $('section#subject .notice-data-sharing').hide();
        }
    },

    /**
     * Update the content container/wrapper height.
     */
    updateContainerHeight: function() {
        $('main#content > .col').matchHeight();
        M.updateTextFields();
    },

    updateContainerHeightOnTextarea: function() {
        $('.input-field textarea').on('input propertychange', function() {
            $.fn.matchHeight._update();
        });
    },

    decodeHtml: function(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },
};

module.exports = new FrontDashboardEventsForm();
